import React from "react";
import { Award, BadgeCheck, Coffee, Coins, Crown, Flame, Heart, Image, Layers, MessageCircle, Send, Share2, Sliders, ThumbsUp, TrendingUp, Trophy, UserCheck, Users } from "lucide-react";
import { IUserStats } from "types";
import { colourScheme } from "utils/styling/colours";
import { StatCard, StatIcon, StatLabel, StatsContainer, StatsGrid, StatValue } from "./StatisticsDisplay.styled";
const iconMap: { [key in keyof IUserStats]: React.ComponentType } & {
  default: React.ComponentType;
} = {
  "Images Generated": Image,
  "Total Likes": Heart,
  "Requests Made": Send,
  "Premium Requests": Crown,
  "Competitions Entered": Trophy,
  "Competitions Won": Award,
  Followers: Users,
  Following: UserCheck,
  "Achievements Earned": BadgeCheck,
  "Comments Made": MessageCircle,
  "Comment Likes Given": ThumbsUp,
  "Stat Blocks Created": Layers,
  "Daily Gold Bonuses Collected": Coins,
  "Current Login Streak": Flame,
  "Max Login Streak": TrendingUp,
  "Number of Presets Created": Sliders,
  "Number of Referrals Made": Share2,
  default: Coffee
};
export default function StatisticsDisplay({
  stats
}: {
  stats: IUserStats;
}) {
  return <StatsContainer suppressHydrationWarning data-sentry-element="StatsContainer" data-sentry-component="StatisticsDisplay" data-sentry-source-file="index.tsx">
            <StatsGrid data-sentry-element="StatsGrid" data-sentry-source-file="index.tsx">
                {Object.entries(stats).map(([key, value]) => {
        const IconComponent = iconMap[key as keyof IUserStats] || iconMap.default;
        return <StatCard key={key} whileHover={{
          y: -5,
          boxShadow: `0 10px 30px -15px ${colourScheme.shadow}`
        }}>
                            <StatIcon>
                                <IconComponent />
                            </StatIcon>
                            <StatValue>{value}</StatValue>
                            <StatLabel>{key}</StatLabel>
                        </StatCard>;
      })}
            </StatsGrid>
        </StatsContainer>;
}